import * as React from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler, set } from 'react-hook-form';
import {useEffect, useState} from 'react';
import { useNavigate } from "react-router-dom";
import InfoAdminModalDelete from './InfoAdminModalDelete';
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../../lib/baseUrlApi';
import Utility from '../../../Consts/Utility';
import { modalProps } from '../../../Consts/constants';
import {ApiRequest} from "../../../Consts/ApiRequest";

type infoInputs = {
  infoRecno: number;
  infoDetail: {
    message: string;
    isLineNotify: boolean;
  };
  link: string;
  linkMessage: string;
  infoKind: boolean;
  isComplete: boolean;
  infoDatetime: {
    start: string;
    end: string;
  };
};

interface infoProps {
  prcKind: number
  start: string;
  end: string;
  infoKind: number;
  infoRecno: number;
  message: string;
  link: string;
  isLineNotify: boolean;
  setState: Function;
  onClose: Function;
  linkMessage: string;
}

const InfoModal = (props: infoProps) => {
  const infoRecno = props.infoRecno;
  const [open, setOpen] = React.useState(false);
  const [infoData, setInfoData] = useState<infoInputs[]>([]);
  const [isLineNotify, setIsLineNotify] = useState<boolean>(props.isLineNotify);
  const prcKind = props.prcKind;

  const formatStart = Utility.formatDateStr(props.start)
  const formatEnd = Utility.formatDateStr(props.end)
  const [start, setStart] = useState<string>(formatStart)
  const [end, setEnd] = useState<string>(formatEnd);
  const [message, setMessage] = useState<string>(props.message);
  const [link, setLink] = useState<string>(props.link);
  const [linkMessage, setLinkMessage] = useState<string>(props.linkMessage);
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [randKey, setRandKey] = useState<string>(Math.random().toString(32).substring(2));
  const [infoKind, setInfoKind] = useState<number>(props.infoKind);
  const { register, handleSubmit, formState: { errors } } = useForm<infoInputs>();
  const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
  const [error, setError] = useState<[]>([]);
  const onCloseProp = props.onClose;

  const resetData = async() => {
    setInfoData([]);
    setIsLineNotify(props.isLineNotify);
    console.log(props.start);
    setStart(Utility.formatDateStr(props.start));
    setEnd(Utility.formatDateStr(props.end));
    setMessage(props.message);
    setLink(props.link);
    setLinkMessage(props.linkMessage);
    setIsComplete(false);
    setInfoKind(props.infoKind);
    setError([]);
  }

  const handleOpen = async() => {
    resetData();
    setOpen(true);
  }
  const handleClose = async() => {
    resetData();
    setOpen(false);
  }

  const close = () => {
    handleClose();
    onCloseProp();
  }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

  const onSubmit: SubmitHandler<infoInputs> = async (data) => {
    const StartReformattedDate = Utility.ReformatDate(start);
    const EndReformattedDate = Utility.ReformatDate(end);
    try {

        const token = cookies.access_token || "";
        let params = {
            "infoRecno": infoRecno,
            "infoKind": infoKind,
            "prcKind": prcKind,
            "infoDatetime": {
                "start": StartReformattedDate,
                "end": EndReformattedDate,
            },
            "infoDetail": {
                "message": message,
                "link": link,
                "linkTitle": "linkTitle",
                "linkMessage": linkMessage,
                "isLineNotify": isLineNotify
            },
            "isComplete": isComplete,
        };

        ApiRequest.registInfo(params,  token, (response:any) => {
            if (Array.isArray(response.data)) {
                setInfoData(response.data);
            }
            setError(response.data.messsages);
            if (response.data.result === 0) {
                close();
            }
            if (response.data.result === -1) {
                console.error("Error fetching data:", error);
            }
        }, (error:any) => {
            errorCallback(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      close();
    }
  };

  return (
    <div>
      <button onClick={handleOpen} className={`btn ${prcKind === 1 ? 'btn-blue-line' : 'btn-blue'}`}>
        <i className={prcKind === 1 ? 'icon-edit-b' : 'icon-add-w'}></i>
        {prcKind === 1 ? '編集' : 'お知らせ追加'}
      </button>
      <Modal {...modalProps} open={open} onClose={handleClose}>
        <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">
                {prcKind === 1 ? 'お知らせ編集' : 'お知らせ新規追加'}
              </div>
              <a onClick={close} className="modal-close"></a>
            </div>
            <div className="modal-body">
              <div className="edit-box">
                {
                  error && error.length > 0 ?
                    <ul className="error-box">
                      {error.map((err, index) => <li key={index}>{err}</li>)}
                    </ul>
                    : null
                }
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">お知らせ開始日<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="date"
                      value={Utility.formatDate(new Date(start))}
                      min="0000-01-01"
                      max="9999-12-31"
                      onChange={(e) => setStart(e.target.value)}
                      className="col-320 error-disp"
                      name={"start"}
                    />
                    {errors.infoDatetime?.start && <p className="error-msg">{errors.infoDatetime.start.message}</p>}
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">お知らせ終了日<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="date"
                      value={Utility.formatDate(new Date(end))}
                      min="0000-01-01"
                      max="9999-12-31"
                      onChange={(e) => setEnd(e.target.value)}
                      className="col-320 error-disp"
                      name={"end"}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">種別</div>
                  <div className="edit-box-elm-input col-320">
                    <input
                      type="radio"
                      id="r1"
                      name="infoKind"
                      value={0}
                      checked={infoKind == 0}
                      onChange={(e) => setInfoKind(0)}
                    />
                    <label htmlFor="r1">お知らせ</label>
                    <input
                      type="radio"
                      id="r2"
                      name="infoKind"
                      value={1}
                      checked={infoKind == 1}
                      onChange={(e) => setInfoKind(1)}
                    />
                    <label htmlFor="r2">障害情報</label>
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">メッセージ<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <textarea
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      className="col-320"
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">リンクURL</div>
                  <div className="edit-box-elm-input col-320">
                    <input
                      type="text"
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                      className="col-320"
                    />
                    <></>
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">URLメッセージ</div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      value={linkMessage}
                      onChange={(e) => setLinkMessage(e.target.value)}
                      className="col-320"
                    />
                  </div>
                </div>

                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">LINE通知</div>
                  <div className="edit-box-elm-input col-320">
                    <input
                      type="radio"
                      id="lineNotify1"
                      name="lineNotify"
                      value={"true"}
                      checked={isLineNotify}
                      onChange={(e) => setIsLineNotify(true)}
                    />
                    <label htmlFor="lineNotify1">通知する</label>
                    <input
                      type="radio"
                      id="lineNotify2"
                      name="lineNotify"
                      value={"false"}
                      checked={!isLineNotify}
                      onChange={(e) => setIsLineNotify(false)}
                    />
                    <label htmlFor="lineNotify2">通知しない</label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="model-action-sub">
                {prcKind === 1 ? (
                  <InfoAdminModalDelete infoRecno={infoRecno}
                    closeModal={close} />
                ) : null}
              </div>
              <div className="model-action-main">
                <button className="btn btn-blue-line">
                  <a onClick={close} className="">
                    キャンセル
                  </a>
                </button>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button className="btn btn-blue col-160">
                    <i className="icon-check-w"></i>確定
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default InfoModal;
